<template>
  <section class="facturacion">
    <div class="facturacion__media">
      <picture>
        <source media="(max-width: 768px)" srcset="../../../../Cliente/assets/bienvenida_billing_mobile.webp" />
        <source media="(max-width: 1024px)" srcset="../../../../Cliente/assets/Bienvenida_billing_tablet.webp" />
        <img
          src="../../../../Cliente/assets/bienvenida_billing.webp"
          alt="Facturación"
          class="facturacion__image"
        />
      </picture>
    </div>
    <div class="facturacion__content">
      <DsChip label="Facturación" variant="orange" />

      <div class="facturacion__title">
        <DsText as="h4" class="section-title_bebas" color="var(--ds-secondary-main)">Solicita tu facturación</DsText>
      </div>

      <DsText as="body3" class="facturacion__intro">
        Para generar tu factura, envia a
        <strong>atencionaclientes@hircasa.com.mx</strong>
      </DsText>

      <div class="facturacion__badges">
        <article v-for="item in items" :key="item.title" class="facturacion__badge">
          <img :src="item.icon" alt="" aria-hidden="true" class="facturacion__badge-icon" />
          <DsText as="body3" color="var(--ds-secondary-main)">{{ item.title }}</DsText>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import DsChip from '../atoms/DsChip.vue'
import DsText from '../atoms/DsText.vue'
import billingA from '../../../assets/bienvenida-mobile/icon-identificacion.svg'
import billingB from '../../../assets/bienvenida-mobile/icon-constancia.svg'

const items = [
  {
    title: 'Identificación oficial',
    icon: billingA,
  },
  {
    title: 'Constancia fiscal',
    icon: billingB,
  },
]
</script>

<style scoped>
.facturacion {
  display: grid;
  grid-template-columns: minmax(320px, 1fr) minmax(0, 1.72fr);
  gap: 28px;
  align-items: center;
}

.facturacion__media {
  position: relative;
  min-height: 545px;
}

.facturacion__media picture {
  display: block;
  width: 100%;
  height: 100%;
}

.facturacion__image {
  width: 100%;
  height: 100%;
  min-height: 545px;
  object-fit: cover;
  object-position: center;
  border-radius: 28px;
  display: block;
}

.section-title_bebas {
  font-family: var(--ds-font-family-bebas);
}

.facturacion__icon {
  position: absolute;
  top: 22px;
  left: 22px;
  width: 42px;
  height: 42px;
  z-index: 1;
  opacity: 0.45;
}

.facturacion__content {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.facturacion__title {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.facturacion__intro {
  color: var(--ds-text-primary);
  line-height: 1.5;
  max-width: 820px;
}

.facturacion__badges {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 28px;
  margin-top: 4px;
}

.facturacion__badge {
  min-height: 64px;
  height: 64px;
  border-radius: 12px;
  border: 1px solid rgba(47, 45, 116, 0.16);
  background: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  box-sizing: border-box;
}

.facturacion__badge-icon {
  display: block;
  width: 40px;
  height: 40px;
  min-width: 40px;
  object-fit: contain;
}

@media (max-width: 1024px) {
  .facturacion {
    grid-template-columns: 1fr;
  }

  .facturacion__media,
  .facturacion__image {
    min-height: 360px;
  }

  .facturacion__image--desktop {
    display: none;
  }
}

@media (min-width: 1025px) {
  .facturacion { display: block; }
  .facturacion__media { display: none; }
  .facturacion__content { gap: 32px; }
  .facturacion__intro { margin-top: -16px; line-height: 24px; }
  .facturacion__badges { gap: 28px; margin-top: 0; }
  .facturacion__badge { border-radius: 8px; }
}

@media (max-width: 768px) {
  .facturacion { display: block; }
  .facturacion__media { display: none; }
  .facturacion__content { gap: 32px; }
  .facturacion__badges {
    grid-template-columns: 1fr;
  }

  .facturacion__media {
    min-height: 300px;
  }

  .facturacion__image--desktop {
    display: none;
  }
}
</style>
